export const LEADERSHIP_DATA = [
  {
    title: "Board of Directors",
    members: [
      {
        id: 1,
        name: "Mukesh Thakur",
        position: "President",
        image: "",
      },
      {
        id: 6,
        name: "Christine Fox",
        position: "Vice-President",
        image: "",
      },
      {
        id: 7,
        name: "Martha Smith",
        position: "General Secretary",
        image: "",
      },
      {
        id: 5,
        name: "Ram Dat Thakur",
        position: "Member",
        image: "",
      },
      {
        id: 3,
        name: "Chandra Devi",
        position: "Member",
        image: "",
      },
      {
        id: 2,
        name: "Uma Adhikari",
        position: "Member",
        image: "",
      },
      {
        id: 4,
        name: "Ram Brikashya Thakur",
        position: "Member",
        image: "",
      },
    ],
  },
  {
    title: "Program Management",
    members: [
      {
        id: 1,
        name: "Laxman Phuyal",
        position: "Program Director / Finance Director",
        image: "/leaders/laxman_ph.jpg",
      },
    ],
  },
  {
    title: "Finance and Administration",
    members: [
      {
        id: 1,
        name: "Pranav Ashok",
        position: "HR Manager",
        image: "",
      },
      {
        id: 2,
        name: "Anju Poudel",
        position: "Finance Manager",
        image: "",
      },
    ],
  },
  {
    title: "Fundraising and Development",
    members: [
      {
        id: 1,
        name: "Lok Prasad Poudel",
        position: "Fundraising & Development Coordinator",
        image: "/leaders/lok_nath.jpg",
      },
      {
        id: 6,
        name: "Ujwal Subedi",
        position: "Fundraising & Development Manager",
        image: "/leaders/ujjwal_subedi.jpg",
      },
      {
        id: 5,
        name: "Bandita Magar",
        position: "Fundraising & Development Officer",
        image: "/leaders/bandita_mgr.jpg",
      },
      {
        id: 4,
        name: "Barsha Pandey",
        position: "Fundraising & Development Officer",
        image: "/leaders/barsha_pa.jpg",
      },
      {
        id: 3,
        name: "Uma Adhikari",
        position: "Donor Relations Officer",
        image: "",
      },
      {
        id: 2,
        name: "Shreya Aher",
        position: "Risk Analyst & Grant Writers",
        image: "",
      },
    ],
  },
  {
    title: "Operations and Logistics",
    members: [
      {
        id: 1,
        name: "Kushal Sharma Bastakoti",
        position: "Operations Manager",
        image: "/leaders/kushal_bs.jpg",
      },
      {
        id: 3,
        name: "Rajeet Nakarmi",
        position: "Design & Experience Lead",
        image: "/leaders/rajeet_na.jpg",
      },
      {
        id: 2,
        name: "Milan Rokaya",
        position: "IT Officer",
        image: "/leaders/milan_r.jpg",
      },
      {
        id: 4,
        name: "Asish Poudel",
        position: "Graphics Designer",
        image: "/leaders/aashish_po.jpg",
      },
      {
        id: 5,
        name: "Bijay Gautam",
        position: "Photographer",
        image: "/leaders/bijaya_ga.jpg",
      },
    ],
  },
  {
    title: "Communications and Public Relations",
    members: [
      {
        id: 1,
        name: "Deeparshan Khadka",
        position: "Communications Director",
        image: "/leaders/deeparshan_kh.jpg",
      },
      {
        id: 2,
        name: "Prasuna Gyawali",
        position: "PR / Marketing Specialist",
        image: "/leaders/prasuna_ga.jpg",
      },
    ],
  },
];
